import styled from 'styled-components';

export const FormInputContainer = styled.div`
  position: relative;
`;

export const TagsField = styled.div<{ $hasError?: boolean; $disabled?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  width: 100%;
  min-height: 46px;
  padding: 6px 8px;
  border: 1px solid
    ${({ theme, $hasError }) => ($hasError ? theme.colors.red800 : theme.colors.neutral100)};
  border-radius: 4px;
  font-size: 18px;
  transition: border-color 0.2s;
  background: ${({ theme, $disabled }) => ($disabled ? theme.colors.neutral200 : theme.colors.neutral)};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'text')};

  &:focus-within {
    outline: none;
    border-color: ${({ theme, $hasError }) =>
      $hasError ? theme.colors.red800 : theme.colors.primary600};
  }
`;

export const TagChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 100%;
  padding: 4px 6px 4px 10px;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.neutral800};
  background-color: ${({ theme }) => theme.colors.neutral200};
  border: 1px solid ${({ theme }) => theme.colors.neutral100};
`;

export const TagText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TagRemove = styled.button.attrs({ type: 'button' })`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.colors.neutral600};
  cursor: pointer;
  border-radius: 2px;

  &:hover {
    color: ${({ theme }) => theme.colors.neutral900};
  }

  svg {
    width: 14px;
    height: 14px;
    display: block;
  }
`;

export const TagInput = styled.input`
  flex: 1 1 80px;
  min-width: 60px;
  border: none;
  outline: none;
  padding: 4px 2px;
  font-size: 18px;
  background: transparent;
  color: inherit;

  &::placeholder {
    color: ${({ theme }) => theme.colors.neutral500};
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

export const ErrorMessage = styled.span`
  display: flex;
  align-items: end;
  gap: 0.3rem;
  color: ${({ theme }) => theme.colors.red800};
  font-size: 12px;
  margin-top: 0.5rem;
`;
